// extracted by mini-css-extract-plugin
module.exports = {"heraldica":"_2-1Fz7c6RC2MbfrqJEdUM2"};